
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ir/library/financial-announcement",
      function () {
        return require("private-next-pages/ir/library/financial-announcement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ir/library/financial-announcement"])
      });
    }
  